/*
 * @Description: 申请单 – 付款申请（SAP）
 */
import { RootObject } from '@/model/rootObject'
import https, { downloadExcel } from '@/utils/https'
import { ContentType, Method } from 'axios-mapper'
import {
  SAPRequestIdListModel,
  SAPRequestListParamModel, SAPRequestModel, SAPRequestPageModel, SAPRequestPageParamModel,
  SAPRequestSetPaymentDateModel,
  SAPSelectedResultModel, SAPSetPurposeParamModel
} from '@/model/application-form/paymentRequestSap'
import networkConfig from '@/config/default/net.config'

const baseUrl = '/base/payment/sap'

export const excelSAPFileUpload = () => {
  return networkConfig.host + baseUrl + '/import/excel'
}

export const getSAPRequestPageList = (params: SAPRequestPageParamModel) => {
  return https().request<RootObject<SAPRequestPageModel>>(baseUrl + '/list', Method.POST, params, ContentType.json)
}

export const getSAPRequestPageListByUser = (params: SAPRequestPageParamModel) => {
  return https().request<RootObject<SAPRequestPageModel>>(baseUrl + '/listByUser', Method.POST, params, ContentType.json)
}

export const getSAPRequestAllList = (params: SAPRequestListParamModel) => {
  return https().request<RootObject<SAPRequestModel[]>>(baseUrl + '/list/all', Method.POST, params, ContentType.json)
}

export const setSAPPaymentDate = (params: SAPRequestSetPaymentDateModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/set/paymentDate', Method.POST, params, ContentType.json)
}

export const generateSAPApprovalForms = (params: SAPRequestIdListModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/generate/approvalForms', Method.POST, params, ContentType.json)
}

export const getSAPRequestByIds = (params: SAPRequestIdListModel) => {
  return https()
    .request<RootObject<SAPSelectedResultModel[]>>(baseUrl + '/get/selectedApprovalForms', Method.POST, params, ContentType.json)
}

export const cancelSAPApplication = (params: SAPRequestIdListModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/cancel/application', Method.POST, params, ContentType.json)
}

export const setSAPSetPurpose = (params: SAPSetPurposeParamModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/set/purpose', Method.POST, params, ContentType.json)
}

export const exportSAPTemplate = () => {
  return downloadExcel(baseUrl + '/export/excelTemplate', Method.GET, undefined)
}
